import React from 'react'
import { Document } from '../landingpage/components/document';
import { Footer } from '../landingpage/components/footer';

export class Privacy extends React.Component {

    render() {
        return (
            <>
            <title>Privacy Policy - TigerCity AI</title>
            <div className="scroll">
                    <div className="document-view">
                        <Document classes="main">
                            <h1>Privacy Policy</h1>
                            <p>This page provides the privacy policy of the TigerCity AI platform.</p>
                            
                        </Document>
                    </div>
                    <Footer/>
                </div>
            </>
        )
    }
}